import styled from 'styled-components';

import { mediaBreakpointMixin, Spacer } from '@zillow/constellation';

export const ShowOnlyOnDesktopWrapper = styled(Spacer)`
  @media ${mediaBreakpointMixin('md_lte')} {
    display: none;
  }
`;

export const ShowOnlyOnMobileWrapper = styled.div`
  @media ${mediaBreakpointMixin('lg')} {
    display: none;
  }
`;
